
import css from 'styled-jsx/css';

const styles = css.global`/* @styled-jsx=global */

#layout-wrapper.g2-page {
  .section--featureSpotlight {
    margin-top: 0;
    margin-bottom: 0;
  }

  .feature-spotlight__background {
    padding: 0;

    &::after {
      height: 0;
    }
  }
}
`;

export default styles;